var ics = require('./lib/ics.js');

module.exports = ics;


//////////////////
// WEBPACK FOOTER
// ./~/ics/index.js
// module id = 1048
// module chunks = 0